<template>
  <div class="agent-console" v-if="getLoggedStatus">
    <div class="agent-console__wrapper" v-show="active==='console'">
      <div class="agent-console__header">
        <!-- <div class="agent-console__header-wrapper"> -->
          <!-- <div class="agent-console__header-agent-info"> -->
            <!-- <p>
              {{ $t('agent-console.agent') }}: {{ agent.number }}
            </p>
            <br> -->
          <!-- </div> -->
          <!-- <div class="agent-console__header-online-status">
            <span>{{ textCallLogged }}</span>
            <span>Chat</span>
          </div>
        </div> -->
        <div class="agent-console__header-agent-buttons">
          <el-button @click="handleBreakOut" :disabled="!getLoggedInCallCenter" :class="['agent-console__agent-buttons-break', { 'agent-console__agent-buttons-break--active': getBreakStatus.name !== ''}]">{{ getBreakStatus.name === "" ? 'Tomar descanso' : 'Salir de descanso'}}</el-button>
          <el-button @click="$emit('make-call')" :disabled="!getLoggedInCallCenter">Llamar</el-button>
        </div>
      </div>
      <div class="agent-console__content">
        <the-activity-box @select-chat="active='chat'"></the-activity-box>
      </div>
    </div>
    <the-break-menu v-if="active==='breakMenu'" @cancel="active='console'" @break-selected="active='console'"></the-break-menu>
    <the-accept-chat-window v-if="active==='acceptChatWindow'" @chat-accepted="chatAccepted" @close-window="closeWindow" :is-widget="true"></the-accept-chat-window>
    <div v-if="active === 'chat'" class="agent-console__chat">
      <div class="agent-console__chat-header">
        <div class="agent-console__chat-header-left-container">
          <i @click="active='console'" class="fas fa-arrow-left"></i>
        
          <p>{{ chatId }}</p>
        </div>
        <the-chat-buttons v-if="active === 'chat' && activeItem.type === 'chat'" :chat-id="chatId" :room-id="chatRoomId" :active="isAgentLogged && activeItem.active" :user-type="activeItem.data.from" @showTransferDrawer="active = 'transferChat'" />
      </div>
      <Chat v-if="active === 'chat' && activeItem.type === 'chat'" ref="chat"  :room-id="chatRoomId" :display-textarea="isAgentLogged && activeItem.active" :key="chatRoomId"
        :myself="agent" :path="getChatPath" :user-type="activeItem.data.from" :emojis="false" :reply="false"
        class="console-chat" :enable-is-writing="false" @click.native="cleanUnreadMessages" @sendedMessage="handleSendedMessage"
        :character-limit="activeItem.data.from === 'whatsapp' ? 1600 : 0"
        >
        <template v-slot:chatTextArea v-if="!showChatTextArea">
          <div class="chat__waiting-for-client-answer-container" v-if="activeItem.data['waitingForClientAnswer']">
            <span>{{ $t('chat.waiting-for-client-answer') }}</span>
          </div>
        </template>
      </Chat>
    </div>
   <the-transfer-chat v-if="active === 'transferChat'" :isWidget="true" @chatTransferred="active = 'console'"></the-transfer-chat> 
  </div>
  <agent-not-sign-in v-else></agent-not-sign-in>
</template>
<script>
// import Chronometer from '@/components/common/Chronometer.vue'
import TheBreakMenu from '@/views/softphone-widget/TheBreakMenu.vue'
import AgentNotSignIn from '@/components/agent-console/AgentNotSignIn.vue'
import TheActivityBox from '@/components/softphone-widget/TheActivityBox.vue'
import TheAcceptChatWindow from '@/components/agent-console/TheAcceptChatWindow.vue'
import TheChatButtons from '@/components/agent-console/TheChatButtons.vue'
import TheTransferChat from '../../components/agent-console/TheTransferChat.vue'
import Chat from  '@/components/chat/Chat.vue'

import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AgentConsole',
  components: {
    // Chronometer,
    TheBreakMenu,
    AgentNotSignIn,
    TheActivityBox,
    TheAcceptChatWindow,
    TheChatButtons,
    TheTransferChat,
    Chat
  },
  props: {
    agent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      softphoneState: null,
      active: 'console'
    }
  },
  methods: {
    ...mapActions(['setPendingChatAcept', 'resetUnreadMessages']),
    handleSoftPhoneEvent(event) {
      this.$emit('softphone-event', event);
    },
    changeSoftphoneState(state) {
      this.softphoneState = state;
    },
    handleBreakOut(){
      console.log(this.getBreakStatus)
      if(this.getBreakStatus.name !== ''){
        this.$store.dispatch('unBreak');
        this.$emit('unbreak');
        return;
      }
      this.active = 'breakMenu';
      this.$emit('break');
    },
    chatAccepted () {
      this.setPendingChatAcept(null);
      this.active = 'chat'
    },
    closeWindow () {
      this.active = 'console'
      this.setPendingChatAcept(null);
    },
    handleSendedMessage(id) {
      if (this.activeItem.type === 'chat' && this.activeItem.data.from === 'whatsapp') {
        this.$store.dispatch('_chats/listenToMessage', { roomId: this.chatRoomId, messageId: id })
      }
    },
    cleanUnreadMessages() {
      this.resetUnreadMessages(this.chatRoomId);
    }
  },
  computed: {
    ...mapGetters({
      getBreakStatus: 'getBreak',
      getLogged: 'getLogged',
      getLoggedInCallCenter: 'getLoggedInCallCenter',
      getLoggedInChatCenter: 'getLoggedInChatCenter',
      showAcceptWindow: 'getShowAcceptChatWindow',
      getChatPath: 'getChatPath',
      activeItem: 'getActiveItem'
    }),
    getLoggedStatus () {
      return this.getLogged
    },
    textCallLogged () {
      return this.getLoggedInCallCenter
        ? this.$t("agent-console.online")
        : this.$t("agent-console.offline");
    },
    chatRoomId() {
      console.log(this.activeItem)
      return this.activeItem.data.roomId;
    },
    isAgentLogged() {
      if (this.agent.id && this.getLoggedInChatCenter) {
        return true;
      }
      return false;
    },
    showChatTextArea() {
      return this.isAgentLogged && !this.activeItem?.data?.waitingForClientAnswer
    },
    chatId() {
      return typeof this.activeItem?.data?.chatId ===  'number' ? this.activeItem.data.chatId.toString() : this.activeItem.data.chatId;
    }
  },
  watch:{
    showAcceptWindow(value){
      if(value){
        this.active = 'acceptChatWindow'
      }
    }
  }  
  
}
</script>
<style scoped>
.agent-console{
  height: 100%;
}
.agent-console__header{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.agent-console__header-wrapper{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.agent-console__header .agent-console__header-online-status{
  font-size: .8em;
  display: flex;
  gap: 10px;
  color: green;
}
.agent-console__header-agent-info{
  font-size: 15px;
  line-height: 10px;
}
.agent-console__header-agent-buttons{
  display: flex;
  justify-content: center;
  gap: 5px;
  overflow-x: auto;
}
.agent-console__header-agent-buttons button{
  font-size: 12px !important;
}
.agent-console__agent-buttons-break--active{
  background: #f56c6c;
  color: white;
}
.agent-console__chat-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.agent-console__chat-header-left-container{
  display: flex;
  align-items: center;
  gap: 5px;
}
.console-chat{
  height: 100%;

}
.agent-console__chat{
  height: 100%;
  max-height: 385px;
}
.fa-arrow-left{
  color: var(--hiperpbx-green);
  font-size: 20px;
  cursor: pointer;
}
</style>